import React, { Component } from 'react';
import { Grid, GridCell } from 'rmwc/Grid';
import { connect } from 'react-redux';
import {Button} from 'rmwc/Button';
import { Snackbar } from 'rmwc/Snackbar';
import { Typography } from 'rmwc/Typography';
import { Card } from 'rmwc/Card';
import * as api from '../../api/api';
import StatusMessage from '../../util/StatusMessage'
import ResourceComponent from './ResourceComponent';

class StandaloneResources extends Component {
	constructor(props) {
		super(props)
    	this.state = {
    		data: {
            	standaloneResources: []
           	}
    	}
    }

    handleBackAction = (e) => {
    	e.preventDefault()
    	this.props.history.push(`/portal/app/admin/learning_taxonomies/resources`)
    }

    componentDidMount(){
    	this.handleResourceFetch()
    }

    handleResourceFetch = (e) => {
        let data = Object.assign({}, this.state.data)

    	let fetchStandaloneResources = 'admin/learning_resource/standalone'
    	return api.getResponse(this.props.user.accessToken, fetchStandaloneResources)
    	.then((result) => {
    		if (result.status === 'success'){
    			data.standaloneResources = result.data
    			this.setState({data: data})
    		}
    	})
    }

    render() {
    	let handleBackAction = this.handleBackAction
    	let handleResourceFetch = this.handleResourceFetch
    	let individualResource

    	if (this.state.data.standaloneResources.length > 0) {
            individualResource = (
                <Grid className="opportunity-list-item">
                    {this.state.data.standaloneResources.map(function(resource){
                        let uniq = Math.random() * resource.id 
                        return (
                            <GridCell span = "12" key = {uniq}>
                                <Card style={{padding: '0px'}}>
                                    <ResourceComponent resourceId = {resource.id}
                                        resourceName = {resource.name}
                                        resourceAuthor = {resource.author}
                                        resourceDescription = {resource.description}
                                        shortDescription = {resource.short_description}
                                        resourceLink = {resource.resource_link}
                                        resourceLanguage = {resource.language}
                                        languageId = {resource.language_id}
                                        resourceComplexity = {resource.complexity}
                                        complexityId = {resource.complexity_id}
                                        resourceCreationDate = {resource.created_at}
                                        resourceStatus = {resource.active}
                                        resourceType = {resource.resource_type}
                                        buzzwords = {resource.buzzwords}
                                        centaRating = {resource.centa_rating}
                                        ratings = {resource.rating}
                                        resourceClass = {resource.resource_class}
                                        onHandleResourceFetch = {handleResourceFetch}
                                        parentTags = {resource.parent_tags}
                                        isAdmin = {true}
                                        bookmarkFeature = {false} 
                                        archiveFeature = {false}
                                    />
                                </Card>
                            </GridCell>
                        )
                    })}
                </Grid>
            )
        }
        else {
            individualResource = (
                <Grid className="opportunity-list-item">
                    <GridCell span = "12">
                        <Card style={{padding: '25px'}}>
                            <Typography> There are currently no Standalone resources.</Typography>
                        </Card>
                    </GridCell>
                </Grid>
            )
        }

        return (
        	<div>
				<Grid>
					<GridCell span = "12">
						<Card style={{padding: '0px'}}>
                            <Grid>
                                <GridCell span="11">
                                    <Typography use="headline5">Standalone Resources</Typography>
                                </GridCell>
                                <GridCell span="1">
                                    <Button raised style={{ width: '100%' }} onClick={((e) => handleBackAction(e))}>Back</Button>
                                </GridCell>
                            </Grid>
						</Card>
					</GridCell>
                    <GridCell span = "12">
                        <Typography>Standalone Resources are the resources that do not have any aspect association which automatically leads to severing ties with Standards. A standalone resources cannot be created. Only an existing resource in the database can be modified with the removal of associations which lead to the resource becoming standalone.</Typography>
                    </GridCell>
				</Grid>
                {individualResource}
			</div>
        )
    }
}

function mapStateToProps({user, admin}) {
  return {
    user,
    admin
  }
}

function mapDispatchToProps() {
  return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(StandaloneResources);


// WEBPACK FOOTER //
// ./src/views/learning_resource_admin/StandaloneResources.jsx